/**
 * Main ClubLoop Golf Categories (order 1–15).
 * Specialized for the golf equipment marketplace.
 */
export const mainCategories = [
  {
    id: 'drivers',
    name: 'Drivers',
    icon: 'golf-club',
    subcategories: ['Men','Women'],
    order: 1
  },
  {
    id: 'iron-sets',
    name: 'Iron Sets',
    icon: 'irons',
    subcategories: ['Steel- Shafted', 'Graphite-Shafted'],
    order: 2,
  },
  {
    id: 'putters',
    name: 'Putters',
    icon: 'putter',
    subcategories: ['Blade Putters', 'Mallet Putters', 'Counterbalanced', 'Arm Lock'],
    order: 3,
  },
  {
    id: 'fairway-woods-hybrids',
    name: 'Woods & Hybrids',
    icon: 'woods',
    subcategories: ['3-Woods', '5-Woods', '7-Woods', 'Hybrids', 'Utility Clubs'],
    order: 4,
  },
  {
    id: 'wedges',
    name: 'Wedges',
    icon: 'wedge',
    subcategories: ['Gap Wedges', 'Sand Wedges', 'Lob Wedges', 'Specialty Grinds'],
    order: 5,
  },
  {
    id: 'full-sets',
    name: 'Full Box Sets',
    icon: 'full-set',
    subcategories: ['Beginner Sets', 'Senior Sets', 'Intermediate Packages'],
    order: 6,
  },
  {
    id: 'golf-bags',
    name: 'Golf Bags',
    icon: 'bag',
    subcategories: ['Stand Bags', 'Cart Bags', 'Staff Bags', 'Travel Covers', 'Sunday Bags'],
    order: 7,
  },
  {
    id: 'golf-carts-trolleys',
    name: 'Carts & Trolleys',
    icon: 'cart',
    subcategories: ['Push Carts', 'Electric Trolleys', 'Motorized Carts', 'Spare Parts'],
    order: 8,
  },
  // {
  //   id: 'apparel-men',
  //   name: "Men's Apparel",
  //   icon: 'apparel',
  //   subcategories: ['Polos', 'Trousers & Shorts', 'Outerwear', 'Caps & Belts'],
  //   order: 9,
  // },
  // {
  //   id: 'apparel-women',
  //   name: "Women's Apparel",
  //   icon: 'apparel-w',
  //   subcategories: ['Polos & Sleeveless', 'Skirts & Skorts', 'Outerwear', 'Caps'],
  //   order: 10,
  // },
  {
    id: 'golf-shoes',
    name: 'Golf Shoes',
    icon: 'shoe',
    subcategories: ['Spiked Shoes', 'Spikeless Shoes', 'Summer Shoes', 'Winter/Gore-Tex'],
    order: 11,
  },
  {
    id: 'tech-rangefinders',
    name: 'Golf Tech',
    icon: 'electronics',
    subcategories: ['Laser Rangefinders', 'GPS Watches', 'Launch Monitors', 'Swing Sensors'],
    order: 12,
  },
  // {
  //   id: 'balls-gloves-acc',
  //   name: 'Balls & Accessories',
  //   icon: 'golf-ball',
  //   subcategories: ['Premium Balls', 'Practice Balls', 'Gloves', 'Tees & Towels', 'Headcovers'],
  //   order: 13,
  // },
  {
    id: 'training-aids',
    name: 'Training Aids',
    icon: 'training',
    subcategories: ['Putting Mats', 'Hitting Nets', 'Swing Planes', 'Alignment Aids'],
    order: 14,
  },
  // {
  //   id: 'club-services',
  //   name: 'Services & Fitting',
  //   icon: 'tools',
  //   subcategories: ['Re-gripping', 'Shaft Fitting', 'Club Repair', 'Custom Builds'],
  //   order: 15,
  // },
];
